import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
export interface MyTimeEntryApprovalListRequest {
  statuses?: string[];
  startDate: string;
  endDate: string;
}

export interface ManagerTaskApprovalResponse {
  taskDate: string;
  totalTimeSpent: string;
  comments?: string;
  status: string;
  approvedById: number;
  approvedByName: string;
  submittedBy: string;
  submittedById: number;
  submittedOn: string;
  responsesUpdatedOn?: string;
  tasks: ManagerTaskDetailResponse[];
}
export interface ManagerTaskDetailResponse {
  projectName: string;
  taskTypeName: string;
  ticketId?: string;
  comment?: string;
  timeSpent: string; // formatted as hh:mm
}
export interface TaskApprovalData {
  effectiveDate: string;
  status: string;
  comments?: string;
}

export interface ManagerTimeEntryUpdateRequest {
  submittedById: number;
  taskApprovalData: TaskApprovalData[];
  isReportingManagerEntry?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ManagerApprovalService {
  private readonly endpoint = 'time-entry-approval';
  constructor(private apiService: ApiService) {}

  getTimeEntries(request: MyTimeEntryApprovalListRequest) {
    const params: any = {
      startDate: request.startDate,
      endDate: request.endDate,
    };

    if (request.statuses?.length) {
      params.statuses = request.statuses;
    }

    return this.apiService.get<ManagerTaskApprovalResponse[]>(
      `${this.endpoint}/manager-approval-requests`,
      { params },
    );
  }

  updateEntries(request: ManagerTimeEntryUpdateRequest) {
    return this.apiService.put(`${this.endpoint}/manager-response`, request);
  }
}
